import styled, { css } from "styled-components";
import { typography } from "screens/Homepage/components/typography";
import { LinkMarketingButton } from "screens/Homepage/styles";
import { Icon } from "@beamcloud/design-system";

export const renderValue = (value: boolean | string) => {
  if (typeof value === "string") {
    return value;
  }

  if (value) {
    return <Icon icon="far-check" color="blue11" />;
  }

  return <Icon icon="far-minus" color="gray11" />;
};

export const Table = styled.table`
  ${({ theme }) => {
    return css`
      table-layout: fixed;
      width: 100%;
      max-width: 1024px;
      border-spacing: 0;
      border-style: hidden;

      tbody {
        :first-of-type tr:first-child td {
          color: ${theme.colors.gray12};
          ${theme.styleSet.textBasePlus};
          padding: 24px 24px 8px;
        }

        :not(:first-of-type) tr:first-child td {
          color: ${theme.colors.gray12};
          ${theme.styleSet.textBasePlus};
          padding: 40px 24px 8px;
        }

        tr {
          :first-child td {
            color: ${theme.colors.gray12};
            ${theme.styleSet.textBasePlus};
            padding: 24px 24px 8px;
          }

          :not(:first-child) td {
            color: ${theme.colors.gray11};
            ${theme.styleSet.textSmPlus};
            padding: 16px 24px;
            border-bottom: 1px solid ${theme.colors.gray6};
          }
        }
      }
    `;
  }}
`;

export const TableCell = styled.td<{ $isPrimary?: boolean; $isHeader?: boolean; $isFooter?: boolean }>`
  ${({ theme, $isPrimary = false, $isHeader = false, $isFooter = false }) => {
    let PrimaryCSS = css``;
    let HeaderCSS = css``;
    let FooterCSS = css``;

    if ($isPrimary) {
      PrimaryCSS = css`
        background-color: ${theme.colors.gray3};
        border-left: 1px solid ${theme.colors.gray7};
        border-right: 1px solid ${theme.colors.gray7};
        box-shadow: ${theme.shadows.sm};
      `;

      if ($isHeader) {
        PrimaryCSS = css`
          ${PrimaryCSS};
          border-top: 1px solid ${theme.colors.gray7};
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        `;
      } else if ($isFooter) {
        PrimaryCSS = css`
          ${PrimaryCSS};
          border-bottom: 1px solid ${theme.colors.gray7};
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        `;
      }
    }

    if ($isHeader) {
      HeaderCSS = css`
        padding: 24px 24px 0px;
      `;
    }

    if ($isFooter) {
      FooterCSS = css`
        padding: 40px 24px 24px;
      `;
    }

    return css`
      ${PrimaryCSS};
      ${HeaderCSS};
      ${FooterCSS};
    `;
  }}
`;

export const PlanNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const PlanName = styled.label`
  ${({ theme }) => {
    return css`
      all: unset;
      color: ${theme.colors.blue11};
      margin-bottom: 6px;
      ${theme.styleSet.textLgPlus};

      @media (max-width: ${theme.breakpoints.sm}px) {
        ${theme.styleSet.textBasePlus};
      }
    `;
  }}
`;

export const PlanPrice = styled.h4`
  ${({ theme }) => {
    return css`
      all: unset;
      color: ${theme.colors.gray12};
      margin-bottom: 8px;
      ${typography.title32};
    `;
  }}
`;

export const PlanPriceTag = styled.p`
  ${({ theme }) => {
    return css`
      all: unset;
      color: ${theme.colors.gray11};
      margin-bottom: 8px;
      ${typography.textSmLight};
    `;
  }}
`;

export const GetStartedWrapper = styled.div<{ $isPrimary?: boolean }>`
  ${({ theme, $isPrimary = false }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: 100%;
      gap: ${$isPrimary ? "12px" : "16px"};

      p {
        all: unset;
        ${typography.textSmLight};
        color: ${$isPrimary ? `${theme.colors.blue11}` : `${theme.colors.gray11}`};
        margin-bottom: ${$isPrimary ? "4px" : "0px"};
      }
    `;
  }}
`;

export const GetStartedButton = css`
  && {
    ${({ theme }) => {
      return css`
        ${theme.styleSet.textBasePlus};
        height: 40px;
      `;
    }}
  }
`;

export const PrimaryGetStartedButton = styled(LinkMarketingButton).attrs({
  outerWidth: "100%",
  width: "100%"
})`
  ${GetStartedButton};
`;

export const SecondaryGetStartedButton = styled(LinkMarketingButton).attrs({
  outerWidth: "100%",
  width: "100%",
  buttonTheme: "secondary",
  variant: "outline"
})`
  ${GetStartedButton};
`;
